<template>
    <div>
        <base-header class="pb-6" type="">
            <b-row class="align-items-center py-4">
            <b-col lg="12" cols="12">
                <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
                <h6 class="h2 d-inline-block mb-0">{{language_terms[$route.name]}}</h6>
                <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                <route-breadcrumb/>
                </nav>
            </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <div>
                <loading :active.sync="loading" 
                    color= '#007bff'
                    :width= '128'
                    :height= '128'
                    loader='dots'
                    :can-cancel="true" 
                    :is-full-page="true">
                </loading>
            </div>
            <b-row>
                <b-col cols="12">
                    <b-card>
                        <div slot="header" class="mb-0">
                            <h3>{{language_terms['DELIVERY_ORDER']}}</h3>
                        </div>
                        <b-row v-if="this.$route.params.id == '_new'">
                            <b-col cols="12">
                                <form-wizard @on-complete="onComplete" title="" subtitle="" color="#5e72e4" :finishButtonText="language_terms['SUBMIT']">
                                    <tab-content :title="language_terms['WAREHOUSE_AND_MOVEMENT_SELECTION']" :before-change="beforeStepChangeFirstTab">
                                        <b-row>
                                            <b-col cols="3">
                                                <base-input :label="language_terms['TYPE']">
                                                    <el-select v-model="delivery_order.type" filterable :placeholder="language_terms['TYPE']">
                                                        <el-option
                                                            v-for="option in types"
                                                            :key="option.code"
                                                            :label="language_terms[option.name]"
                                                            :value ="option.code">
                                                        </el-option>
                                                    </el-select>
                                                </base-input>
                                            </b-col>
                                            <b-col cols="3">
                                                <base-input :label="language_terms['WAREHOUSE']">
                                                    <el-select v-model="delivery_order.warehouse_id" filterable :placeholder="language_terms['WAREHOUSE']">
                                                        <el-option
                                                            v-for="option in warehouses"
                                                            :key="option.id"
                                                            :label="option.name"
                                                            :value ="option.id">
                                                        </el-option>
                                                    </el-select>
                                                </base-input>
                                            </b-col>
                                            <b-col cols="3">
                                                <label class="form-control-label">{{language_terms["CUSTOMER"]}}</label>
                                                <multiselect
                                                        :internalSearch = "false"
                                                        v-model="delivery_order.customer"
                                                        id="ajax"
                                                        label="name"
                                                        track-by="id"
                                                        placeholder="Type to search"
                                                        open-direction="bottom"
                                                        :options="customers"
                                                        :multiple="false"
                                                        :searchable="true"
                                                        :clear-on-select="false"
                                                        :close-on-select="true"
                                                        :options-limit="300"
                                                        :limit="50"
                                                        :max-height="600"
                                                        :show-no-results="false"
                                                        :hide-selected="false"
                                                        @search-change="asyncFindCustomer"
                                                        @input="onSelectCustomer"
                                                >
                                                </multiselect>
                                            </b-col>
                                            <b-col cols="3">
                                                <base-input :label="language_terms['DATE']">
                                                    <flat-picker
                                                        slot-scope="{ focus, blur }"
                                                        @on-open="focus"
                                                        @on-close="blur"
                                                        style="background-color: white"
                                                        class="form-control datepicker"
                                                        v-model="delivery_order.date">
                                                    </flat-picker>
                                                </base-input>
                                            </b-col>
                                            <b-col cols="12" v-if="delivery_order.type == 'DO_SO'">
                                                <base-input :label="language_terms['SALES_ORDERS']" >
                                                    <el-select v-model="delivery_order.reference_id" filterable :placeholder="language_terms['SALES_ORDERS']" >
                                                        <el-option
                                                            v-for="option in sos"
                                                            :key="option.document_id"
                                                            :label="option.code"
                                                            :value ="option.document_id">
                                                        </el-option>
                                                    </el-select>
                                                </base-input>
                                            </b-col>
                                            <b-col cols="12">
                                                <base-input :label="language_terms['REMARKS']">
                                                    <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" v-model="delivery_order.remarks"></textarea>
                                                </base-input>
                                            </b-col>
                                        </b-row>
                                    </tab-content>
                                    <tab-content :title="language_terms['DO_ITEMS']">
                                        <b-row>
                                            <b-col cols="6">
                                                <label class="form-control-label">{{language_terms['PRODUCT']}}</label>
                                                <productLookup v-bind:url="apiProductLookup" v-on:selected="selectProduct($event)" :lookupId="delivery_order.product_code"/>
                                            </b-col>
                                            <b-col cols="5">
                                                <base-input v-model="delivery_order.allocate_qty" type="number" :label="language_terms['QTY']"></base-input>
                                            </b-col>
                                            <b-col lg="11" v-if="(delivery_order.is_trade == '1')">
                                                <label class="form-control-label">{{language_terms["PRODUCT_NAME"]}}</label>
                                                <multiselect
                                                        v-model="delivery_order.trade_item"
                                                        label="product_name"
                                                        track-by="product_name"
                                                        placeholder="Type to search"
                                                        open-direction="bottom"
                                                        :options="tradeitem_desp_list"
                                                        :multiple="false"
                                                        :searchable="true"
                                                        :clear-on-select="false"
                                                        :close-on-select="true"
                                                        :options-limit="300"
                                                        :limit="50"
                                                        :max-height="600"
                                                        :show-no-results="false"
                                                        :hide-selected="true"
                                                        @search-change="asyncFindTradeItemDesp($event)"
                                                        :internalSearch = "false"
                                                        :taggable="true"
                                                        @tag="addTag($event)"
                                                        @select="onSelectTradeItemDesp($event)"
                                                    >
                                                </multiselect>
                                            </b-col>
                                        <b-col cols="1" class="mt-4">
                                            <base-button icon type="success" @click="addToDoItems" class="mt-1">
                                                {{language_terms['ADD']}}
                                            </base-button>
                                        </b-col>
                                        </b-row>
                                        <b-row v-if="delivery_order.items.length > 0">
                                            <b-col cols="12">
                                                <b-table-simple hover responsive>
                                                    <b-thead head-variant="light">
                                                        <b-th>{{language_terms['PRODUCT_CODE']}}</b-th>
                                                        <b-th>{{language_terms['PRODUCT_NAME']}}</b-th>
                                                        <b-th>{{language_terms['SO_QTY']}}</b-th>
                                                        <b-th>{{language_terms['BALANCE']}}</b-th>
                                                        <b-th>{{language_terms['AVAILABLE_QTY']}}</b-th>
                                                        <b-th>{{language_terms['QTY']}}</b-th>
                                                        <b-th></b-th>
                                                    </b-thead>
                                                    <b-tbody v-for="(item, index) in delivery_order.items" :key="index">
                                                        <tr>
                                                            <td>{{item.product_code}}</td>
                                                            <td>
                                                                {{item.product_name}}
                                                            </td>
                                                            <td>
                                                                {{item.qty}} 
                                                            </td>
                                                            <td>
                                                                {{item.balance_qty}} 
                                                            </td>
                                                            <td>
                                                                {{item.available_qty}}
                                                            </td>
                                                            <td>
                                                                <base-input v-model="item.allocate_qty" type="number" @change="onChangeAllocateQty(item, index)" :disabled="item.is_visible == '0'" v-if="delivery_order.type == 'DO_SO'"></base-input>
                                                                <base-input v-model="item.allocate_qty" type="number" v-if="delivery_order.type == 'DO'"></base-input>
                                                            </td>
                                                            <td>
                                                                <base-button  size="sm" icon type="danger" @click="deleteItem(index)" class="mr-4" :disabled="item.is_visible == '0'"><i class="fas fa-trash-alt"></i ></base-button>
                                                                <base-button @click="handleCollaspe(index, item)" size="sm" icon type="success" v-if="item.lots.length"><i class="fa fa-angle-down"></i></base-button>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="item.is_collapsed">
                                                            <td colspan="6">
                                                                <b-collapse v-model="item.is_collapsed" class="mt-2">
                                                                    <b-table-simple responsive>
                                                                    <b-thead head-variant="light">
                                                                            <b-th>{{language_terms['LOCATION']}}</b-th>
                                                                            <b-th>{{language_terms['LOT_NUMBER']}}</b-th>
                                                                            <b-th>{{language_terms['EXPIRY_DATE']}}</b-th>
                                                                            <b-th>{{language_terms['LOT_QTY']}}</b-th>
                                                                            <b-th>{{language_terms['ALLOCATE_QTY']}}</b-th>
                                                                    </b-thead>
                                                                    <b-tbody v-for="(lot, j) in item.lots" :key="j">
                                                                        <td>{{lot.location_name}}</td>
                                                                        <td>{{lot.lot_reference}}</td>
                                                                        <td>{{lot.expiry_date}}</td>
                                                                        <td>{{lot.qty}}</td>
                                                                        <td>
                                                                            <input v-model="lot.allocate_qty" type="number" class="form-control" v-if="lot.is_disabled == '0'"/>     
                                                                            <span v-if="lot.is_disabled == '1'">{{lot.allocate_qty}}</span>                                                          
                                                                        </td>
                                                                    </b-tbody>
                                                                    </b-table-simple>
                                                                </b-collapse>
                                                            </td>
                                                        </tr>
                                                    </b-tbody>
                                                </b-table-simple>
                                            </b-col>
                                        </b-row>
                                    </tab-content>
                                </form-wizard>
                            </b-col>
                        </b-row>
                        <b-row v-else>
                            <b-col cols="6">
                                <base-input :label="language_terms['CUSTOMER']" :placeholder="language_terms['CUSTOMER']" v-model="delivery_order.contact_name" disabled></base-input>
                            </b-col>
                            <b-col cols="6">
                                <base-input :label="language_terms['DATE']" :placeholder="language_terms['DATE']" v-model="delivery_order.movement_date" disabled></base-input>
                            </b-col>
                            <b-col cols="6">
                                <base-input :label="language_terms['WAREHOUSE']" :placeholder="language_terms['WAREHOUSE']" v-model="delivery_order.location_name" disabled></base-input>
                            </b-col>
                            <b-col cols="6">
                                <base-input :label="language_terms['REFERENCE']" :placeholder="language_terms['REFERENCE']" v-model="delivery_order.reference_code" disabled></base-input>
                            </b-col>
                            <b-col cols="12">
                                <base-input :label="language_terms['REMARKS']" >
                                    <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" v-model="delivery_order.remarks" disabled></textarea>
                                </base-input>
                            </b-col>
                            <b-col cols="12">
                                <h3>{{language_terms['DO_ITEMS']}}</h3>
                                    <b-table-simple hover responsive class="mt-3">
                                    <b-thead head-variant="light">
                                        <b-th>{{language_terms['PRODUCT_CODE']}}</b-th>
                                        <b-th>{{language_terms['PRODUCT_NAME']}}</b-th>
                                        <b-th>{{language_terms['QTY']}}</b-th>
                                        <b-th>{{language_terms['LOT_NUMBER']}}</b-th>
                                        <b-th>{{language_terms['EXPIRY_DATE']}}</b-th>
                                        <b-th>{{language_terms['LOCATION']}}</b-th>
                                    </b-thead>
                                    <b-tbody>
                                        <tr v-for="(item, index) in delivery_order.items" :key="index">
                                            <td>{{item.product_code}}</td>
                                            <td>{{item.product_name}}</td>
                                            <td>{{item.qty}}</td>
                                            <td>{{item.lot_reference}}</td>
                                            <td>{{item.expiry_date}}</td>
                                            <td>{{item.location_name}}</td>
                                        </tr>
                                    </b-tbody>
                                </b-table-simple>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="1">
                                <base-button icon type="primary" @click.native ="goBack" v-if="$route.params.id != '_new'">
                                    {{language_terms['BACK']}}
                                </base-button>
                            </b-col>
                            <b-col cols="2">
                                <printDocument :data="delivery_order" v-if="($route.params.id != '_new')"></printDocument> 
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import { mapState } from "vuex";

import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { Select, Option } from "element-ui";

import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";
import productLookup from "@/components/Autocomplete.vue";
import moment from "moment";

import printDocument from "./printDo.vue"

export default {
    computed:{
    ...mapState({
        language_terms: state => state.languages.language_terms,
        warehouses:(state)=>state.locations.warehouses,
        is_delivery_order_created:(state) => state.delivery_orders.is_delivery_order_created,
        so_list:(state) => state.sales.so_list,
        so_items:(state) => state.sales.so_items,
        is_stockcard_created:(state) => state.stockcards.is_stockcard_created,
        do_data:(state) =>state.dos.data,
        lots:(state) => state.stockcards.lots,
      }),
    },
    components:{
        FormWizard,
        TabContent,
        Loading,
        [Select.name]: Select,
        [Option.name]: Option,
        flatPicker,
        productLookup,
        printDocument
    },
    data(){
        return{
            apiProductLookup: apiRoutes["PRODUCT_LOOKUP"],
            loading:false,
            customers:[],
            tradeitem_desp_list:[],
            desp_tags:[],
            sos:[],
            delivery_order:{
                items:[],
                warehouse_id:null,
                type:"DO",
                warehouse_id:null,
                date:null,
                contact_id:null,
                contact_name:"",
                contact_code:"",
                reference_code:"",
                reference_id:null,
                remarks:"",
                is_trade:"0",
                trade_item:{},
                customer:{
                    id:"",
                    code:"",
                    name:""
                }
            },
            types:[
                {
                    code:"DO_SO",
                    name:"DO_FROM_SO"
                },
                {
                    code:"DO",
                    name:"DELIVERY_ORDER"
                }
            ],
        }
    },
    methods:{
        async addToDoItems()
        {
            let product_id = this.delivery_order.product_id
            let has_lot = this.delivery_order.has_lot
            let expiry_mths = this.delivery_order.expiry_mths

            await this.$store.dispatch("stockcards/retrieveLots", 
            {
                product_id:product_id, 
                warehouse_id:this.delivery_order.warehouse_id, 
                has_lot:has_lot, 
                expiry_mths:expiry_mths,
                movement_date:this.delivery_order.movement_date
            })

            let qty = this.delivery_order.allocate_qty * 1

            if(has_lot == '1' || expiry_mths)
            {
                if(this.lots.length > 0)
                {
                    let available_qty = 0;
                    for(let i = 0; i < this.lots.length; i++)
                    {
                        available_qty = available_qty + this.lots[i].qty;
                        if(this.lots[i].qty >= qty)
                        {
                            this.lots[i].allocate_qty =  qty
                        }
                        else
                        {
                            this.lots[i].allocate_qty = this.lots[i].qty
                        }

                        qty = qty - this.lots[i].allocate_qty
                    }
                
                    this.delivery_order.items.push(
                    {
                        is_collapsed:false,
                        lots:this.lots,
                        warehouse_id:this.delivery_order.warehouse_id,
                        product_id:this.delivery_order.product_id,
                        product_code:this.delivery_order.product_code,
                        product_name:this.delivery_order.product_name,
                        location_id:this.delivery_order.location_id,
                        location_code:this.delivery_order.location_code,
                        location_name:this.delivery_order.location_name,
                        allocate_qty:this.delivery_order.allocate_qty,
                        available_qty:available_qty,
                        lot_reference:this.delivery_order.lot_reference,
                        expiry_date:this.delivery_order.expiry_date,
                        remarks:this.delivery_order.item_remarks
                    })
                }
                else
                {
                    alert("Invalid Qty")
                }
            }
            else
            {
                // Product Without lots or without expiry
                let available_qty = 0;
                for(let i = 0; i < this.lots.length; i++)
                {
                    available_qty = available_qty + this.lots[i].qty
                    if(this.lots[i].qty >= qty)
                    {
                        this.lots[i].allocate_qty =  qty
                    }
                    else
                    {
                        this.lots[i].allocate_qty = this.lots[i].qty
                    }

                    qty = qty - this.lots[i].allocate_qty
                }
                
                this.delivery_order.items.push(
                {
                    is_collapsed:false,
                    lots:this.lots,
                    warehouse_id:this.delivery_order.warehouse_id,
                    product_id:this.delivery_order.product_id,
                    product_code:this.delivery_order.product_code,
                    product_name:this.delivery_order.product_name,
                    location_id:this.delivery_order.location_id,
                    location_code:this.delivery_order.location_code,
                    location_name:this.delivery_order.location_name,
                    allocate_qty:this.delivery_order.allocate_qty,
                    lot_reference:this.delivery_order.lot_reference,
                    expiry_date:this.delivery_order.expiry_date,
                    remarks:this.delivery_order.item_remarks,
                    available_qty:available_qty,
                })

                this.delivery_order.location = {}
                this.delivery_order.location_id = '';
                this.delivery_order.location_code = '';
                this.delivery_order.location_name= '';

                this.delivery_order.product_code = '';
                this.delivery_order.product_id = '';
                this.delivery_order.product_name = "",
                this.delivery_order.has_lot = 0;
                this.delivery_order.expiry_date = null,
                this.delivery_order.allocate_qty = '',
                this.delivery_order.expiry_mths = ""
                this.delivery_order.trade_item = {}
            }
     
        },
        isFoundInList(name)
        {
            let is_found = 0
            for(let i = 0; i < this.desp_tags.length; i++)
            {
                if(this.desp_tags[i].product_name == name)
                {
                is_found = 1
                }
            }
            return is_found;
        },
        addTag(newTag)
        {
            if(newTag)
            {
                let obj = {product_name: newTag, contact_id:this.delivery_order.contact_id, date:this.delivery_order.movement_date}
                if(this.isFoundInList(newTag) == 0)
                {
                    this.desp_tags.push(obj)
                    Array.prototype.push.apply(this.tradeitem_desp_list, this.desp_tags); 
                    this.delivery_order.trade_item = obj
                    this.delivery_order.product_name = newTag
                }

            }
        },
        onSelectTradeItemDesp(selectedOption)
        {
            if(selectedOption)
            {
                this.delivery_order.product_name = selectedOption.product_name
            }
        },
        async asyncFindTradeItemDesp (query) 
        {
            let product_id = this.delivery_order.product_id
            let pv = { value: query, contact_id:this.delivery_order.contact_id, date:this.delivery_order.movement_date, product_id: product_id};
            axios.post(apiRoutes["TRADE_ITEM_DESP_LOOKUP"], pv, authHeader()).then((response) => {
            if (response.data.code == 1) 
            {
                this.tradeitem_desp_list = response.data.data
                Array.prototype.push.apply(this.tradeitem_desp_list, this.desp_tags); 
            } 
            else 
            {
                this.tradeitem_desp_list = []
            }
            })
            .catch((error) => 
            {
            if (error.response) 
            {
                Vue.notify({
                group: "notify",
                type: "error",
                text: error.response.data.msg,
                max: 5,
                duration: 5000,
                speed: 300,
                });
            } 
            else 
            {
                console.log("Problem Querying Data", error);
            }
            });
        },
        async selectProduct(obj)
        {
            if(obj)
            {
                this.delivery_order.expiry_date = null
                this.delivery_order.product_id = obj.id
                this.delivery_order.product_code = obj.code
                this.delivery_order.product_name = obj.name
                this.delivery_order.has_lot = obj.has_lot
                this.delivery_order.expiry_mths = obj.expiry_mths
                this.delivery_order.is_trade = obj.is_trade


                if(this.delivery_order.is_trade == '1')
                {
                    this.delivery_order.product_name = ''
                }

                if(this.delivery_order.movement_date && this.delivery_order.expiry_mths)
                {
                    this.delivery_order.expiry_date = moment(this.delivery_order.movement_date).add(this.delivery_order.expiry_mths, "months").format("YYYY-MM-DD");
                }

            }
        },
        goBack()
        {
            this.$router.push("/inventory/dos")
        },
        async onChangeAllocateQty(item, index)
        {
            if(item)
            {
                await this.$store.dispatch("sales/validateSoQtyForDo" , {document_item_id:item.id, allocate_qty:item.allocate_qty})
                item.allocate_qty = item.allocate_qty * 1

                if(item.allocate_qty > this.allow_qty)
                {
                    item.allocate_qty = this.allow_qty
                    this.$set(this.delivery_order.items, index , item) 
                }
            }
            
        },
        deleteItem(index)
        {
            this.delivery_order.items.splice(index, 1);
        },
        handleCollaspe(index, row)
        {
            if(row.is_collapsed)
            {
                row.is_collapsed = false
            }
            else
            {
                row.is_collapsed = true
            }

            this.$set(this.delivery_order.items, index , row) 
        },
        async asyncFindCustomer(query) 
        {
            let pv = { value: query };
            await axios.post(apiRoutes["CUSTOMER_LOOKUP"], pv, authHeader()).then((response) => {
                if (response.data.code == 1) 
                {
                    this.customers = response.data.data;
                } else {
                    this.customers = [];
                }

                this.isLoading = false;
                })
                .catch((error) => {
            if (error.response) {
                alert(error.response.data.msg)
            } else {
                console.log("Problem submitting New Post", error);
            }
            });
        },
        async beforeStepChangeFirstTab()
        {
            let isValid = false

            if(this.delivery_order.contact_id && this.delivery_order.date && this.delivery_order.type == 'DO')
            {
                isValid = true
            }
            else if(this.delivery_order.type == 'DO_SO')
            {
                if(this.delivery_order.reference_id != '' && this.delivery_order.reference_id != null)
                {
                    await this.$store.dispatch("sales/fetchSoItems", {document_id:this.delivery_order.reference_id, 
                    warehouse_id:this.delivery_order.warehouse_id, movement_date:this.delivery_order.date })
                    this.delivery_order.items = this.so_items
                    isValid = true
                }
            }

            return isValid
        },
        async onSelectCustomer(selectedOption)
        {
            if(selectedOption)
            {
                this.delivery_order.contact_id = selectedOption.id

                if(this.delivery_order.type == 'DO_SO')
                {
                    await this.$store.dispatch("sales/fetchSosForDo" , {contact_id:selectedOption.id})

                    if(this.so_list)
                    {
                        this.sos = this.so_list
                    }
                }
            }
        },
        onComplete()
        {
            this.createStockCard()
        },
        async createStockCard()
        {
            if(this.is_confirmed == 0 )
            {
                let payload = {
                                warehouse_id:this.delivery_order.warehouse_id, 
                                reference_id:this.delivery_order.reference_id,
                                remarks:this.delivery_order.remarks,
                                movement_date:this.delivery_order.date, 
                                items:this.delivery_order, 
                                direction:'OUT',
                                type:this.delivery_order.type,
                                contact_id:this.delivery_order.contact_id,
                                is_confirmed:0
                           }
                await this.$store.dispatch("stockcards/create", payload)

                if(this.is_confirmation_required == 1)
                {
                    let messages = this.confirmation_messages
                    let msg = '';
                    if (Array.isArray(messages)) {
                        msg = messages.join("\n")
                    }
                    let response = await this.$confirm(msg, this.language_terms['CONFIRMATION'], {
                        confirmButtonText: this.language_terms['CONFIRM'],
                        cancelButtonText: this.language_terms['CANCEL'],
                        type: 'warning'
                        }).catch(() => 
                        {
                            this.$message.info(this.language_terms['ACTION_CANCEL'])
                        })
                        if (response === 'confirm') 
                        {
                            this.loading = true
                            await this.confirmCreateStockCard()
                            this.loading = false
                        }
                }
            }
            else
            {
                await this.confirmCreateStockCard()
            }

            if(this.is_stockcard_created == 1)
            {
                this.$router.push("/inventory/dos")
            }
        },
        async confirmCreateStockCard()
        {
            let payload = {
                        warehouse_id:this.delivery_order.warehouse_id, 
                        reference_id:this.delivery_order.reference_id,
                        remarks:this.delivery_order.remarks,
                        movement_date:this.delivery_order.date, 
                        items:this.delivery_order.items, 
                        direction:'OUT',
                        type:this.delivery_order.type,
                        contact_id:this.delivery_order.contact_id,
                        is_confirmed:1
            }
            await this.$store.dispatch("stockcards/create", payload)
        },
    },
    async mounted()
    {
        this.loading = true
        await this.$store.dispatch("locations/fetchWarehouses", {});
        let document_code = this.$route.params.id

        if(document_code == '_new')
        {
            if(this.warehouses.length > 0)
            {
                if(!this.delivery_order.warehouse_id)
                {
                    this.delivery_order.warehouse_id = this.warehouses[0].id
                }
            }

            if(!this.delivery_order.date)
            {
                this.delivery_order.date = moment().format("YYYY-MM-DD");
            }
        }
        else
        {
            await this.$store.dispatch("dos/fetch", {code:this.$route.params.id});
            this.delivery_order = this.do_data
        }


        this.loading = false

    }
}
</script>
